import axios from 'axios';

export async function announcementAPI() {
	let announcementData = null;
    
	try{
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}home/announcement`,
			// data: {  },
			headers: { 
				'content-type': 'application/json',
			}
		});

		const { data } = response;
		announcementData = data;
	}
	catch(error) {
		throw error;
		// Message.error();
	}

	return announcementData;
}